import DemoRequest from "interfaces/howItWorks/DemoRequest";
import { DemoUsageLogRequest } from "interfaces/request/DemoUsageLogRequest";
import { getDataAsync, postDataAsync } from "./PortalApi";
import { postDataAsync as postTimePhasingDataAsync } from "./TimePhasingApi";

export const getRequestDemoDataAsync = async (productId: number) => {
  const routeUrl = `Product/${productId}/Demo/Examples`;
  const response = await getDataAsync<any[]>(routeUrl);

  return response;
};

export const getTimePhasedDemoAsync = (data: any) => {
  const url = `TimephaseDemo`;
  return postTimePhasingDataAsync<DemoRequest, any>(url, data);
};

export const logDemoUsageAsync = (data: DemoUsageLogRequest) => {
  const url = "Demo/DemoUsage";
  return postDataAsync<DemoUsageLogRequest, any>(url, data, false);
};
